import { oPopupBorderTop, oPopupPaddingHorizontal } from '@approvalmax/ui';
import styled from 'styled-components';

export const Content = styled.div`
    width: 640px;
    height: 500px;
    display: flex;
    flex-flow: column;
    padding-top: 20px;
    user-select: none;
    ${oPopupBorderTop}
`;

export const Description = styled.div`
    flex: none;
    ${oPopupPaddingHorizontal()};
`;

export const WatcherList = styled.div`
    flex: 1;
    display: flex;
    flex-flow: column;
    overflow-y: auto;
    padding: 20px 0;
    ${oPopupPaddingHorizontal()};

    & > *:not(:last-child) {
        margin-bottom: 10px;
    }
`;
